module.exports = __webpack_public_path__ + "first-20-signature.jpg?8835e50f3a6eb8f687262a8c79a3b03c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-20-signature.jpg
// module id = 463
// module chunks = 0